module.exports = __webpack_public_path__ + "img/mobile_alphaville.457b22c7.webp";